import { SectionAlert, Txt } from '@vst/beam';
import { useTranslation } from 'react-i18next';

export const GeneralErrorAlert = () => {
  const { t } = useTranslation('Network');

  return (
    <SectionAlert
      variant="error"
      size="small"
      contentSlot={
        <Txt variant="smallRegular" color="regular">
          {t('networkManagement.generalErrorAlert')}
        </Txt>
      }
    />
  );
};
